import { CoverDesktop, CoverMobile } from '../Cover'
import { Motivation } from '../Motivation'

export const WhatBringsYouVariantPALM = () => (
  <>
    <div className='d-none d-lg-block'>
      <div className='row no-gutters mc-my-9 mc-border--default mc-corners--lg mc-overflow--hidden'>
        <CoverDesktop />
        <Motivation />
      </div>
    </div>
    <div className='d-lg-none'>
      <CoverMobile />
      <div className='row no-gutters mc-my-7 mc-overflow--hidden'>
        <Motivation />
      </div>
    </div>
  </>
)
